import type React from 'react';
import { useState } from 'react';
import { GuestNameView } from './GuestNameView';
import { JoinView } from './JoinView';
import { Layout } from './Layout';

interface GuestJoinMeetingFlowProps {
  meetingId: string;
  onSignIn: () => void;
  onGuestJoin?: (guestName: string) => void;
}

export const GuestJoinMeetingFlow: React.FC<GuestJoinMeetingFlowProps> = ({
  meetingId,
  onSignIn,
  onGuestJoin,
}) => {
  const [showGuestName, setShowGuestName] = useState(false);

  return (
    <Layout>
      {showGuestName ? (
        <GuestNameView
          meetingId={meetingId}
          onGuestJoin={(name) => onGuestJoin?.(name)}
          onBack={() => setShowGuestName(false)}
        />
      ) : (
        <JoinView
          meetingId={meetingId}
          onSignIn={onSignIn}
          onContinueAsGuest={() => setShowGuestName(true)}
        />
      )}
    </Layout>
  );
};
